import { IQDialog } from '../../../common'
import Button from '@mui/material/Button'

interface IProps {
  isShow: boolean
  isCreate: boolean
  type: 'INT' | 'EXT' | 'TEMPLATE'
  onClose: () => void
  onCancel: () => void
}

export const MembershipCancel = ({ isShow, isCreate, type, onClose, onCancel }: IProps) => (
  <IQDialog
    isShow={isShow}
    title={`Are you sure you want to cancel ${type === 'TEMPLATE' ? 'Template' : 'Membership'} ${isCreate ? 'creation' : 'update'}?`}
    content={
      <>
        <span style={{ fontWeight: 'bold' }}>Please Note!</span> All unsaved changes will be lost.
      </>
    }
    actions={
      <Button
        variant='contained'
        onClick={onCancel}
        data-testid={`${type === 'TEMPLATE' ? 'template' : 'membership'}-cancel-ok`}
      >
        OK
      </Button>
    }
    onClose={onClose}
    testPrefix={`${type === 'TEMPLATE' ? 'template' : 'membership'}-cancel`}
  />
)
